/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { TextareaAutosize } from '@mui/material';
import { useSelector } from 'react-redux';
import { findIndexOfObjectInArray } from '../../utils/array';
import { getId } from '../../utils/item';
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { regexformula } from '../../utils/num';

export const NumSettingsFormula = props => {
  const { num, itemId, numId, updateField, value } = props;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);

  const [copiedCode, setCopiedCode] = useState(null);
  const [formula, setFormula] = useState(num?.formula ?? '');
  const [allUsedItems, setAllUsedItems] = useState([]);
  const [itemNums, setItemNums] = useState([]);
  const [expanded, setExpanded] = useState({
    item: false,
    links: false,
    filters: false,
  });
  const missingLinkedIdsRef = useRef(new Set());

  const readableFormula = strFormula => {
    const escapeHtmlAttr = value => {
      if (value === null || value === undefined) {
        return '';
      }
      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
    };

    const arrF = strFormula?.split(regexformula);
    const replacedF = arrF?.map(step => {
      step = step.replace('[', '').replace(']', '');
      const replacedArr = step.split('.');
      if (replacedArr.length > 1) {
        const filteredParts = replacedArr.filter(
          part => part !== 'useMod' && part !== 'useCon'
        );

        const itemId = filteredParts[0];
        const numRef = filteredParts[1];

        if (itemId === 'links') {
          const linkedIds = Array.isArray(item?.links)
            ? item.links.map(obj => getId(obj)).filter(Boolean)
            : [];
          const matchedItemLabels = [];

          for (const linkedId of linkedIds) {
            const linkedItem = items?.[linkedId];
            if (!linkedItem?.has_num) {
              continue;
            }

            let numIdx = findIndexOfObjectInArray(linkedItem.has_num, numRef);
            if (numIdx === -1) {
              numIdx = linkedItem.has_num.findIndex(numObj => {
                const resolvedNumId = getId(numObj);
                const resolvedNum = numObj?.[resolvedNumId];
                const label =
                  typeof resolvedNum?.label === 'string'
                    ? resolvedNum.label.trim()
                    : '';
                return label !== '' && label === numRef;
              });
            }
            if (numIdx === -1) {
              continue;
            }
            const linkedLabel =
              typeof linkedItem?.label === 'string' ? linkedItem.label : '';
            if (linkedLabel) {
              matchedItemLabels.push(linkedLabel);
            }
          }

          const title =
            matchedItemLabels.length > 0
              ? escapeHtmlAttr(matchedItemLabels.join('\n'))
              : '';
          step = `<div title="${title}" className="bg-primary px-05 py-01 mx-05 shadow rounded text-sm"> 
                <span className="text-opacity-50 text-xs uppercase text-contrast">
                Liens - </span> ${escapeHtmlAttr(numRef)} </div>`;

          if (matchedItemLabels.length === 0) {
            step = `<div className="bg-secondary-d px-05 py-01 mx-05 shadow rounded text-sm"> 
                    erreur </div>`;
          }
          return step;
        }

        if (itemId === 'filter' && filteredParts.length > 3) {
          const filterId = numRef;
          const op = filteredParts[2];
          const numRef4 = filteredParts[3];

          const filterEntry = Array.isArray(item?.filters)
            ? item.filters.find(filterObj => getId(filterObj) === filterId)
            : null;
          const filter = filterEntry ? filterEntry?.[filterId] : null;
          if (!filter) {
            step = `<div className="bg-secondary-d px-05 py-01 mx-05 shadow rounded text-sm"> 
                    erreur </div>`;
            return step;
          }

          const required = Array.isArray(filter?.items) ? filter.items.filter(Boolean) : [];
          const excluded = Array.isArray(filter?.exclude) ? filter.exclude.filter(Boolean) : [];
          const requiredSet = new Set(required);
          const excludedSet = new Set(excluded);

          const candidateIds = [];
          Object.values(items || {}).forEach(candidate => {
            if (!candidate?._id || candidate.__partial === true) return;
            if (item?.universe && candidate?.universe && candidate.universe !== item.universe) return;
            if (!Array.isArray(candidate?.links) || candidate.links.length === 0) return;
            const linkIds = candidate.links.map(obj => getId(obj)).filter(Boolean);
            const linkSet = new Set(linkIds);
            for (const reqId of requiredSet) {
              if (!linkSet.has(reqId)) return;
            }
            for (const exId of excludedSet) {
              if (linkSet.has(exId)) return;
            }
            candidateIds.push(candidate._id);
          });

          const noteEnabled = filter?.noteNumEnabled === true;
          const noteMap =
            filter?.noteNums && typeof filter.noteNums === 'object'
              ? filter.noteNums
              : {};

          const matchedLines = [];
          for (const id of candidateIds) {
            const candidate = items?.[id];
            if (!candidate?.has_num) continue;
            let numIdx = findIndexOfObjectInArray(candidate.has_num, numRef4);
            if (numIdx === -1) {
              numIdx = candidate.has_num.findIndex(numObj => {
                const resolvedNumId = getId(numObj);
                const resolvedNum = numObj?.[resolvedNumId];
                const label =
                  typeof resolvedNum?.label === 'string'
                    ? resolvedNum.label.trim()
                    : '';
                return label !== '' && label === numRef4;
              });
            }
            if (numIdx === -1) continue;
            const qty = noteEnabled
              ? Number.isFinite(Number(noteMap?.[id]))
                ? Number(noteMap[id])
                : 1
              : 1;
            const label = typeof candidate?.label === 'string' ? candidate.label : id;
            matchedLines.push(noteEnabled ? `${label} x${qty}` : label);
          }

          const title =
            matchedLines.length > 0 ? escapeHtmlAttr(matchedLines.join('\n')) : '';
          step = `<div title="${title}" className="bg-primary px-05 py-01 mx-05 shadow rounded text-sm"> 
                <span className="text-opacity-50 text-xs uppercase text-contrast">
                Filtre - </span> ${escapeHtmlAttr(op)}.${escapeHtmlAttr(numRef4)} </div>`;

          if (matchedLines.length === 0) {
            step = `<div className="bg-secondary-d px-05 py-01 mx-05 shadow rounded text-sm"> 
                    erreur </div>`;
          }
          return step;
        }

        if (filteredParts[1] === 'links' && filteredParts.length > 2) {
          const objectIdLikeRegex = /^[a-fA-F0-9]{24}$/;
          const baseRef = itemId;
          const numRef3 = filteredParts[2];

          const linkIds = Array.isArray(item?.links)
            ? item.links.map(obj => getId(obj)).filter(Boolean)
            : [];
          const requiredLinkId =
            baseRef === 'current'
              ? item?._id
              : items?.[baseRef]?._id ||
                (objectIdLikeRegex.test(baseRef) ? baseRef : null);
          if (!requiredLinkId) {
            step = `<div className="bg-secondary-d px-05 py-01 mx-05 shadow rounded text-sm"> 
                    erreur </div>`;
            return step;
          }

          const candidateIds = linkIds.filter(id => {
            const linkedItem = items?.[id];
            if (!linkedItem?.links) return false;
            const linkedLinkIds = linkedItem.links
              .map(obj => getId(obj))
              .filter(Boolean);
            return linkedLinkIds.includes(requiredLinkId);
          });

          const matchedItemLabels = [];
          for (const id of candidateIds) {
            const linkedItem = items?.[id];
            if (!linkedItem?.has_num) continue;

            let numIdx = findIndexOfObjectInArray(linkedItem.has_num, numRef3);
            if (numIdx === -1) {
              numIdx = linkedItem.has_num.findIndex(numObj => {
                const resolvedNumId = getId(numObj);
                const resolvedNum = numObj?.[resolvedNumId];
                const label =
                  typeof resolvedNum?.label === 'string'
                    ? resolvedNum.label.trim()
                    : '';
                return label !== '' && label === numRef3;
              });
            }
            if (numIdx === -1) continue;
            const linkedLabel =
              typeof linkedItem?.label === 'string' ? linkedItem.label : '';
            if (linkedLabel) matchedItemLabels.push(linkedLabel);
          }

          const filterLabel =
            items?.[requiredLinkId]?.label ||
            requiredLinkId ||
            baseRef;
          const title =
            matchedItemLabels.length > 0
              ? escapeHtmlAttr(matchedItemLabels.join('\n'))
              : '';

          step = `<div title="${title}" className="bg-primary px-05 py-01 mx-05 shadow rounded text-sm"> 
                <span className="text-opacity-50 text-xs uppercase text-contrast">
                Liens (${escapeHtmlAttr(filterLabel)}) - </span> ${escapeHtmlAttr(numRef3)} </div>`;

          if (matchedItemLabels.length === 0) {
            step = `<div className="bg-secondary-d px-05 py-01 mx-05 shadow rounded text-sm"> 
                    erreur </div>`;
          }
          return step;
        }

        if (itemId === 'notes') {
          const objectIdLikeRegex = /^[a-fA-F0-9]{24}$/;
          const trimmed = typeof numRef === 'string' ? numRef.trim() : '';
          const targetIds = new Set();
          if (objectIdLikeRegex.test(trimmed)) {
            targetIds.add(trimmed);
          } else {
            // Filters
            if (Array.isArray(item?.filters)) {
              item.filters.forEach(filterObj => {
                const filterId = getId(filterObj);
                const filter = filterObj?.[filterId];
                if (!filter || filter.noteNumEnabled !== true) return;
                const map =
                  filter.noteNums && typeof filter.noteNums === 'object'
                    ? filter.noteNums
                    : null;
                if (!map) return;
                Object.keys(map).forEach(itemId => {
                  const linked = items?.[itemId];
                  const linkedLabel =
                    typeof linked?.label === 'string'
                      ? linked.label.trim()
                      : '';
                  if (linkedLabel && linkedLabel === trimmed) {
                    targetIds.add(itemId);
                  }
                });
              });
            }
            // Reduced item widgets (tab grids)
            if (Array.isArray(item?.tabs)) {
              item.tabs.forEach(tabObj => {
                const tabId = getId(tabObj);
                const tabItem = items?.[tabId];
                if (!Array.isArray(tabItem?.grid)) return;
                tabItem.grid.forEach(gridObj => {
                  const widgetId = getId(gridObj);
                  if (!widgetId || !objectIdLikeRegex.test(widgetId)) return;
                  const cfg = gridObj?.[widgetId];
                  if (!cfg || cfg.noteNumEnabled !== true) return;
                  const widgetItem = items?.[widgetId];
                  const widgetLabel =
                    typeof widgetItem?.label === 'string'
                      ? widgetItem.label.trim()
                      : '';
                  if (widgetLabel && widgetLabel === trimmed) {
                    targetIds.add(widgetId);
                  }
                });
              });
            }
          }

          const titles = [];
          targetIds.forEach(id => {
            const obj = items?.[id];
            const label = typeof obj?.label === 'string' ? obj.label : id;
            titles.push(label);
          });
          const title = titles.length > 0 ? escapeHtmlAttr(titles.join('\n')) : '';
          step = `<div title="${title}" className="bg-primary px-05 py-01 mx-05 shadow rounded text-sm"> 
                <span className="text-opacity-50 text-xs uppercase text-contrast">
                Notes - </span> ${escapeHtmlAttr(trimmed)} </div>`;
          if (titles.length === 0) {
            step = `<div className="bg-secondary-d px-05 py-01 mx-05 shadow rounded text-sm"> 
                    erreur </div>`;
          }
          return step;
        }

        const formItem = itemId === 'current' ? item : items[itemId];
        if (formItem?.has_num) {
          let numIdx = findIndexOfObjectInArray(formItem?.has_num, numRef);
          if (numIdx === -1) {
            // Fallback: allow referencing nums by label: [itemId.numLabel]
            numIdx = formItem.has_num.findIndex(numObj => {
              const resolvedNumId = getId(numObj);
              const resolvedNum = numObj?.[resolvedNumId];
              const label =
                typeof resolvedNum?.label === 'string'
                  ? resolvedNum.label.trim()
                  : '';
              return label !== '' && label === numRef;
            });
          }
          const resolvedEntry = numIdx > -1 ? formItem.has_num?.[numIdx] : null;
          const resolvedNumId = resolvedEntry ? getId(resolvedEntry) : null;
          const num = resolvedNumId ? resolvedEntry?.[resolvedNumId] : null;
          step = `<div className="bg-primary px-05 py-01 mx-05 shadow rounded text-sm"> 
                <span className="text-opacity-50 text-xs uppercase text-contrast">
                ${formItem?.label} - </span> ${num?.label} </div>`;

          if (!formItem?.label || !num?.label) {
            step = `<div className="bg-secondary-d px-05 py-01 mx-05 shadow rounded text-sm"> 
                    erreur </div>`;
          }
        }
      }
      return step;
    });
    const formula = replacedF?.join(' ');
    return formula;
  };

  const addItemValue = (itemCopied, objNum) => {
    const formItem = itemCopied._id === item._id ? 'current' : itemCopied._id;
    const strNum = `[${formItem}.${Object.keys(objNum)}]`;
    navigator.clipboard.writeText(strNum);
    setCopiedCode(
      `${item?.label} - ${objNum[Object.keys(objNum)]?.label} copié`
    );
  };

  const getFilterList = () => {
    if (!Array.isArray(item?.filters)) {
      return [];
    }
    return item.filters
      .map(filterObj => {
        const filterId = getId(filterObj);
        const filter = filterObj?.[filterId];
        return {
          filterId,
          label: filter?.label || 'filtre',
        };
      })
      .filter(entry => entry.filterId);
  };

  const addFilterValue = (filterId, mode = 'id') => {
    if (!filterId) {
      return;
    }
    const ref = num?.label?.trim() ? num.label.trim() : numId;
    const payload =
      mode === 'id'
        ? filterId
        : `[filter.${filterId}.${mode}.${ref}]`;
    navigator.clipboard.writeText(payload);
    setCopiedCode(`filtre ${filterId} copié`);
  };

  useEffect(() => {
    setFormula(num?.formula ?? '');
  }, [numId, num?.formula]);

  const linkedIds = useMemo(
    () =>
      Array.isArray(item?.links)
        ? item.links.map(obj => getId(obj)).filter(Boolean)
        : [],
    [item?.links],
  );

  const linkedItemsStateKey = useMemo(
    () =>
      linkedIds
        .map(id => {
          const cached = items?.[id];
          if (!cached) return `${id}:none`;
          return `${id}:${cached.__partial === true ? 'p' : 'f'}:${
            Array.isArray(cached.has_num) ? cached.has_num.length : 'x'
          }`;
        })
        .join('|'),
    [linkedIds, items],
  );

  useEffect(() => {
    if (copiedCode) {
      setTimeout(() => {
        setCopiedCode(null);
      }, '2000');
    }
  }, [copiedCode]);

  useEffect(() => {
    if (item) {
      const getLinkedItems = async () => {
        if (linkedIds.length === 0) {
          setAllUsedItems([]);
          return;
        }
        const completeFromCache = [];
        const idsToFetch = [];
        linkedIds.forEach(id => {
          if (!id || missingLinkedIdsRef.current.has(id)) {
            return;
          }
          const cached = items?.[id];
          const isComplete =
            cached &&
            !cached.__partial &&
            Array.isArray(cached.has_num);
          if (isComplete) {
            completeFromCache.push(cached);
          } else {
            idsToFetch.push(id);
          }
        });

        const fetchedItems = [];
        if (idsToFetch.length > 0) {
          try {
            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/items/batch`,
              { ids: idsToFetch },
            );
            const fetched = Array.isArray(res?.data) ? res.data : [];
            const fetchedById = new Set(fetched.map(entry => entry?._id).filter(Boolean));
            idsToFetch.forEach(id => {
              if (!fetchedById.has(id)) {
                missingLinkedIdsRef.current.add(id);
              }
            });
            fetchedItems.push(...fetched);
          } catch (error) {
            // Ignore batch failures; keep cache-only view.
          }
        }

        const linkedItems = [...completeFromCache, ...fetchedItems];

        const unique = [
          ...new Map(
            linkedItems.filter(Boolean).map(m => [m._id, m])
          ).values(),
        ];
        setAllUsedItems(unique);
      };

      getLinkedItems();
      const arr = Array.isArray(item?.has_num)
        ? item.has_num.map(numObj => numObj[Object.keys(numObj)])
        : [];
      setItemNums(arr);
    }
  }, [item, linkedIds, linkedItemsStateKey]);

  return (
    <>
      {' '}
      {num?.formula && (
        <div className='w-full flex flex-wrap items-center justify-center mt-1 text-contrast'>
          {parse(readableFormula(num.formula))} = {value}
        </div>
      )}
      <div className='w-full flex'>
        <TextareaAutosize
          aria-label='empty textarea'
          minRows={3}
          style={{ width: '100%' }}
          value={formula ?? ''}
          className='w-full p-05 mt-1 bg-main bg-opacity-50 rounded text-contrast placeholder:text-contrast placeholder:text-opacity-50'
          placeholder={'formule'}
          onChange={e => setFormula(e.target.value)}
          onBlur={() => {
            const cleanedFormula = formula.trim();
            if (cleanedFormula === '') {
              updateField('', 'formula');
            } else {
              updateField(cleanedFormula, 'formula');
            }
          }}
        />
      </div>
      <Accordion
        expanded={expanded.item}
        onChange={() =>
          setExpanded(prev => {
            return { ...prev, item: !prev.item };
          })
        }
      >
        <AccordionSummary
          aria-controls='item-content'
          id='item-header'
        >
          <div className='w-full flex items-center text-contrast'>
            <div className='flex items-center gap-05 flex-1 font-condensed text-lg mb-05 mt-1'>
              {expanded.item ? <FaChevronUp /> : <FaChevronDown />} Nombres de
              l'item
            </div>
            {copiedCode && (
              <div className='text-xs bg-secondary-d rounded px-05 py-03'>
                {copiedCode}
              </div>
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className='w-full flex flex-wrap gap-1 text-contrast'>
            {itemNums?.map((numObj, i) => {
              return (
                <div
                  key={i}
                  className={`bg-primary px-05 py-01 shadow rounded text-sm ${
                    numObj?.label === num?.label ? 'hidden' : ''
                  }`}
                  onClick={() => addItemValue(item, item.has_num[i])}
                >
                  <span className='text-opacity-50 text-sm uppercase text-contrast text-xs'>
                    {item?.label} -
                  </span>{' '}
                  {numObj?.label}
                </div>
              );
            })}
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded.links}
        onChange={() =>
          setExpanded(prev => {
            return { ...prev, links: !prev.links };
          })
        }
      >
        <AccordionSummary
          aria-controls='links-content'
          id='links-header'
        >
          <div className='w-full flex items-center text-contrast'>
            <div className='flex items-center gap-05 flex-1 font-condensed text-lg mb-05 mt-1'>
              {expanded.links ? <FaChevronUp /> : <FaChevronDown />} Nombres des
              items liés
            </div>
            {copiedCode && (
              <div className='text-xs bg-secondary-d rounded px-05 py-03'>
                {copiedCode}
              </div>
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className='w-full flex flex-wrap gap-1 text-contrast'>
            {[...allUsedItems]?.flatMap(item =>
              (Array.isArray(item?.has_num) ? item.has_num : [])
                .map((numObj, i) => {
                const num = numObj[Object.keys(numObj)];
                if (numId === Object.keys(numObj)[0]) {
                  return null;
                }
                return (
                  <div
                    key={`${item?._id}-${Object.keys(numObj)[0] || i}`}
                    className='bg-primary px-05 py-01 shadow rounded text-sm'
                    onClick={() => addItemValue(item, numObj)}
                  >
                    <span className='text-opacity-50 text-sm uppercase text-contrast text-xs'>
                      {item?.label} -
                    </span>{' '}
                    {num?.label}
                  </div>
                );
              })
                .filter(Boolean)
            )}
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded.filters}
        onChange={() =>
          setExpanded(prev => {
            return { ...prev, filters: !prev.filters };
          })
        }
      >
        <AccordionSummary
          aria-controls='filters-content'
          id='filters-header'
        >
          <div className='w-full flex items-center text-contrast'>
            <div className='flex items-center gap-05 flex-1 font-condensed text-lg mb-05 mt-1'>
              {expanded.filters ? <FaChevronUp /> : <FaChevronDown />} Nombres
              des filtres
            </div>
            {copiedCode && (
              <div className='text-xs bg-secondary-d rounded px-05 py-03'>
                {copiedCode}
              </div>
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className='w-full flex flex-col gap-05 text-contrast'>
            {getFilterList().length === 0 ? (
              <div className='text-sm opacity-60'>Aucun filtre sur cet item</div>
            ) : (
              getFilterList().map(filterEntry => (
                <div
                  key={filterEntry.filterId}
                  className='flex flex-wrap items-center gap-05'
                >
                  <div className='text-sm text-contrast text-opacity-70'>
                    {filterEntry.label}
                  </div>
                  <div
                    className='bg-primary px-05 py-01 shadow rounded text-sm cursor-pointer'
                    title='Copier l’id du filtre'
                    onClick={() => addFilterValue(filterEntry.filterId, 'id')}
                  >
                    id
                  </div>
                  <div
                    className='bg-primary px-05 py-01 shadow rounded text-sm cursor-pointer'
                    title='Copier une somme simple (à adapter)'
                    onClick={() => addFilterValue(filterEntry.filterId, 'sum')}
                  >
                    sum
                  </div>
                  <div
                    className='bg-primary px-05 py-01 shadow rounded text-sm cursor-pointer'
                    title='Copier une somme pondérée par les notes (à adapter)'
                    onClick={() =>
                      addFilterValue(filterEntry.filterId, 'sumq')
                    }
                  >
                    sumq
                  </div>
                </div>
              ))
            )}
            <div className='text-xs text-contrast text-opacity-60 mt-05'>
              Astuce : le code copié utilise <code>{num?.label || numId}</code>{' '}
              (label si possible), tu peux remplacer la fin par un autre num.
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  );
};
